
  var _styles = {
  "coupon-modal__wrapper": {
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center"
  },
  "coupon-modal__content-wrapper": {
    "width": "8rem",
    "height": "8.84rem",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.64rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "position": "relative",
    "overflow": "hidden"
  },
  "coupon-modal__title-text": {
    "marginTop": "0.4rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.56rem"
  },
  "coupon-modal__coupon-list-wrapper": {
    "width": "8rem",
    "height": "6.56rem"
  },
  "coupon-modal__scroll-content-wrapper": {
    "width": "8rem",
    "marginTop": "0.13333rem",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "flex-start"
  },
  "coupon-modal__scroll-footer": {
    "width": "8rem",
    "height": "1.33333rem"
  },
  "coupon-modal__coupon-item": {
    "marginBottom": "0.13333rem"
  },
  "coupon-modal__bottom-gradient": {
    "position": "absolute",
    "bottom": "0.86667rem",
    "width": "100%",
    "height": "2.24rem"
  },
  "coupon-modal__bottom-text": {
    "position": "absolute",
    "bottom": "0.26667rem",
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem"
  },
  "cfe-five-city-close-button": {
    "marginTop": "0.70667rem"
  },
  "cfe-five-city-close-button-img": {
    "width": "0.64rem",
    "height": "0.64rem"
  }
};



  module.exports = _styles;
  